// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"UserForm_formContainer__2rxzu","sectionForm":"UserForm_sectionForm__CDvlP","formLabel":"UserForm_formLabel__xuv19"};